export const base64Encode = (str) => btoa(unescape(encodeURIComponent(str)));
export const base64Decode = (str) => decodeURIComponent(escape(atob(str)));
export const parseDecimalToFixedString = (num, fixed = 2) => Number.parseFloat(num).toFixed(fixed);
